export const deviceTypes = [
  {
    key: 'computer',
    label: 'Computer',
    image: '/images/icon-computer.png',
  },
  {
    key: 'tablet',
    label: 'Tablet',
    image: '/images/icon-tablet.png',
  },
  {
    key: 'smartphone',
    label: 'Smartphone',
    image: '/images/icon-smartphone.png',
  },
];

export const defaultOperatingSystems = [
  {
    key: 'ios',
    label: 'iOS',
    image: '/images/ios.png',
    checked: true,
  },
  {
    key: 'android',
    label: 'Android',
    image: '/images/android.png',
    checked: true,
  },
];
